<script>
import RouterActions from "@/mixins/routerActions";

export default {
  mixins: [RouterActions],
  props: {
    markers: Array,
    selected: {
      type: Object,
      required: true,
    },
  },
  computed: {
    map() {
      return this.$parent.map;
    },
    google() {
      return this.$parent.google;
    },
    infoWindow() {
      return new this.google.maps.InfoWindow({
        maxWidth: 500,
      });
    },
  },
  methods: {
    selectBranch(id) {
      let branch = this.markers.filter((item) => item.id === id);
      this.storeSetBranch(branch[0]);
      this.$router.push({
        name: "Step 2",
        params: {
          branch: branch[0].id,
        },
      });
    },
    createMarker(item) {
      const { Marker, LatLng } = this.google.maps;

      const image = {
        url: "/images/marker.png",
        size: this.google.maps.Size(55, 55),
        origin: this.google.maps.Point(0, 0),
        anchor: this.google.maps.Point(0, 55),
      };

      let marker = new Marker({
        title: item.name,
        position: new LatLng(item.lat, item.long),
        map: this.map,
        icon: image,
        zIndex: item.index,
      });

      let content = `
                <div class="map__popup">
                    <div class="row flex-row">
                        <div class="col-10">
                            <h5 class="map__popup--title">${item.name}</h5>
                        </div>
                        <div class="col-2">
                            <span class="map__popup--distance"></span>
                        </div>
                        <div class="col-12 map__popup--line">
                            <div class="d-flex align-items-start">
                                <div class="map__popup--icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512">
                                        <path fill="currentColor" d="M347.94 129.86L203.6 195.83a31.938 31.938 0 0 0-15.77 15.77l-65.97 144.34c-7.61 16.65 9.54 33.81 26.2 26.2l144.34-65.97a31.938 31.938 0 0 0 15.77-15.77l65.97-144.34c7.61-16.66-9.54-33.81-26.2-26.2zm-77.36 148.72c-12.47 12.47-32.69 12.47-45.16 0-12.47-12.47-12.47-32.69 0-45.16 12.47-12.47 32.69-12.47 45.16 0 12.47 12.47 12.47 32.69 0 45.16zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z"></path>
                                    </svg>
                                </div>
                                <div class="map__popup--content">
                                    <h6>${item.address}</h6>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 map__popup--line">
                            <div class="d-flex align-items-start">
                            <div class="map__popup--icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path></svg>
                                </div>
                                <div class="map__popup--content">
                                    <h6>${this.$t("map-list.hours")}</h6>
                                    <p> ${item.hours} </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 map__popup--line">
                            <div class="d-flex align-items-start">
                            <div class="map__popup--icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"></path></svg>
                                </div>
                                
                                <div class="map__popup--content">
                                    <h6>${this.$t("map-list.phone")}</h6>
                                    <p> 
                                        ${item.numbers}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 map__popup--line">
                            <a onclick='selectBranch(${
                              item.id
                            })' class="btn-primary no-hover btn--full">${this.$t(
        "map-list.choose"
      )}</a>
                        </div>
                    </div>
                </div>
            `;
      return { marker, content };
    },
    initMarkers() {
      this.markers.forEach((item) => {
        const { content, marker } = this.createMarker(item);

        const branch = item;

        marker.addListener("click", () => {
          this.$emit("mapBranchActivated", branch);
          this.infoWindow.close();
          this.infoWindow.setContent(content);
          this.infoWindow.open(marker.getMap(), marker);
        });
      });
    },
    openSelectedBranch(item) {
      const { content, marker } = this.createMarker(item);
      this.infoWindow.close();
      this.infoWindow.setContent(content);
      this.infoWindow.open(marker.getMap(), marker);
    },
  },
  mounted() {
    this.initMarkers();
  },
  created() {
    window.selectBranch = this.selectBranch;

    if (this.selected && this.selected.id > 0) {
      this.openSelectedBranch(this.selected);
    }
  },
  render() {
    return null;
  },
};
</script>

<style>
.gm-ui-hover-effect {
  display: none !important;
}
</style>
